import React, { useState } from 'react';
import { ChevronsLeftRightIcon } from 'lucide-react';
type Img = {
  src: string;
  alt: string;
};
type BeforeAfterSliderProps = {
  before: Img;
  after: Img;
};
export function BeforeAfterSlider({
  before,
  after
}: BeforeAfterSliderProps) {
  const [pos, setPos] = useState(50);
  return <div className="relative aspect-square w-full select-none overflow-hidden rounded-2xl bg-forest-dark shadow-xl shadow-forest/10" data-id="element-34" data-mp="2yck4lgr77ykz">
      <img src={after.src} alt={after.alt} className="absolute inset-0 h-full w-full object-cover" draggable={false} data-id="element-35" data-mp="3czvi3o6xxsnq" />
      <img src={before.src} alt={before.alt} className="absolute inset-0 h-full w-full object-cover" style={{
      clipPath: `inset(0 ${100 - pos}% 0 0)`
    }} draggable={false} data-id="element-36" data-mp="384zo4ii58v7z" />

      <span className="pointer-events-none absolute left-3 top-3 rounded-md bg-ink/80 px-2.5 py-1 text-xs font-semibold text-white" data-id="element-37" data-mp="1ro3slpuxaszg">
        Before
      </span>
      <span className="pointer-events-none absolute right-3 top-3 rounded-md bg-leaf px-2.5 py-1 text-xs font-semibold text-white" data-id="element-38" data-mp="1nol7asz6wfw3">
        After
      </span>

      <div className="pointer-events-none absolute inset-y-0 w-0.5 bg-white" style={{
      left: `${pos}%`
    }} aria-hidden="true" data-id="element-39" data-mp="1dk618rjcuaxz">
        <span className="absolute left-1/2 top-1/2 flex h-11 w-11 -translate-x-1/2 -translate-y-1/2 items-center justify-center rounded-full bg-white text-forest shadow-lg" data-id="element-40" data-mp="1iifw111639j2">
          <ChevronsLeftRightIcon className="h-5 w-5" data-id="element-41" data-mp="1saloscz8tuzb" />
        </span>
      </div>

      <input type="range" min={0} max={100} value={pos} onChange={e => setPos(Number(e.target.value))} aria-label="Drag to compare before and after" className="absolute inset-0 h-full w-full cursor-ew-resize opacity-0" data-id="element-42" data-mp="1waw2ycx6vrp9" />
    </div>;
}